import React from 'react';
import { bool, func, string, arrayOf, shape, oneOfType } from 'prop-types';
import { connect } from 'react-redux';

import locationShape from 'propTypes/locationShape';
import coord from 'propTypes/coord';

import { operations as mapOperations } from 'state/ducks/map';
import { operations as segmentCreationOperations } from 'state/ducks/segmentCreation';

import ExistingSegment from '../ExistingSegment';
import PathSuggestion from '../PathSuggestion';

const noop = _ => null;

export function SegmentGroup({
  segments,
  enterEntity,
  leaveEntity,
  currentHover,
  showPathSuggestions,
  pathSuggestions,
  selectedPathSuggestion,
  selectPathSuggestion,
  disableInteraction,
}) {
  // eslint-disable-next-line global-require
  const SortingFeatureGroup = require('components/Map/MapComponents/SortingFeatureGroup').default;
  // eslint-disable-next-line global-require
  const PriorityFeatureGroup = require('components/Map/MapComponents/PriorityFeatureGroup').default;
  const hoveredId = currentHover && currentHover.id;

  // eslint-disable-next-line one-var
  let selectedItem, unselectedItems, showUnselected;

  if (showPathSuggestions) {
    selectedItem = pathSuggestions.find(({ id }) => id === selectedPathSuggestion.id);
    unselectedItems = pathSuggestions.filter(({ id }) => id !== selectedPathSuggestion.id);
    showUnselected = !disableInteraction && unselectedItems.length > 0;
  }

  return (
    <SortingFeatureGroup>
      {showPathSuggestions &&
        <PriorityFeatureGroup priority={20}>
          <PathSuggestion
            key={`${selectedItem.id}-isSelected}`}
            {...selectedItem}
            isSelected
            onSelect={
              disableInteraction
                ? noop
                : () => {
                    selectPathSuggestion(selectedItem.id);
                  }
            }
          />
        </PriorityFeatureGroup>}
      {showUnselected &&
        <PriorityFeatureGroup priority={15}>
          <div>
            {unselectedItems.map(suggestion =>
              <PathSuggestion
                key={`${suggestion.id}`}
                {...suggestion}
                isSelected={false}
                onSelect={
                  disableInteraction
                    ? noop
                    : () => {
                        selectPathSuggestion(suggestion.id);
                      }
                }
              />
            )}
          </div>
        </PriorityFeatureGroup>}
      {Boolean(segments.length) &&
        segments.map(segment => {
          const { id: segmentId } = segment;
          const isActive = segmentId === hoveredId;

          return (
            <ExistingSegment
              key={`segment-${segmentId}${isActive && '-active'}`}
              priority={isActive ? 30 : 10}
              segment={segment}
              isActive={isActive}
              onEnter={() =>
                enterEntity({
                  id: segmentId,
                  type: 'segment',
                })}
              onLeave={() =>
                leaveEntity({
                  id: segmentId,
                  type: 'segment',
                })}
            />
          );
        })}
    </SortingFeatureGroup>
  );
}

SegmentGroup.propTypes = {
  segments: arrayOf(
    shape({
      id: string,
      path: arrayOf(coord),
      from: locationShape,
      to: locationShape,
    })
  ).isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  currentHover: shape({
    id: string.isRequired,
  }),
  showPathSuggestions: bool.isRequired,
  pathSuggestions: oneOfType([
    bool,
    arrayOf(
      shape({
        id: string.isRequired,
        path: arrayOf(coord).isRequired,
      })
    ),
  ]),
  selectedPathSuggestion: oneOfType([
    bool,
    shape({
      id: string.isRequired,
    }),
  ]),
  selectPathSuggestion: func,
  disableInteraction: bool.isRequired,
};

const mapStateToProps = ({ map }) => ({
  currentHover: map.currentHover,
});

export default connect(mapStateToProps, {
  ...mapOperations,
  ...segmentCreationOperations,
})(SegmentGroup);



// WEBPACK FOOTER //
// ./src/components/Map/CreateSegment/SegmentGroup/index.js